import { useEffect } from "react";
import "./App.css";
import { register } from "swiper/element/bundle";
import "./Style/scss/_index.scss";
import AppRoutes from "./AppRoutes/AppRoutes";
import DocumentLoader from "./components/Modals/DocumentLoader";
import { startTokenRefresh } from "./services/tokenRefresh";

function App() {
  register();

  useEffect(() => {
    // Page reload while already logged in — resume the refresh cycle.
    if (localStorage.getItem("isAuthenticated") === "true") {
      startTokenRefresh();
    }
  }, []);

  return (
    <div>
      <AppRoutes />
      <DocumentLoader />
    </div>
  );
}

export default App;
